// Runs ONCE at boot, as a top-level side effect, BEFORE any Zustand slice is
// evaluated. This module is imported first in `index.tsx` and pulls in no store
// — otherwise the slices would read stale data into memory before we wiped it.
//
// localStorage data-version gate: when the stored marker differs from
// `DATA_VERSION` (a returning v1 player has no marker at all, and a future
// breaking deploy bumps the constant), every game key — the whole `usagi`
// namespace — is removed, then the marker is written. A matching marker skips
// the wipe entirely, so legitimate saves survive normal reloads.
//
// Bump `DATA_VERSION` on any deploy whose persisted format is incompatible to
// force a clean slate for returning players.

const DATA_VERSION_KEY = 'usagi_data_version';
const DATA_VERSION = '1';

function isGameKey(key: string): boolean {
  return key.startsWith('usagi_') || key.startsWith('usagi.');
}

try {
  if (localStorage.getItem(DATA_VERSION_KEY) !== DATA_VERSION) {
    const stale: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && isGameKey(key)) {
        stale.push(key);
      }
    }
    for (const key of stale) {
      localStorage.removeItem(key);
    }
    localStorage.setItem(DATA_VERSION_KEY, DATA_VERSION);
  }
} catch {
  /* localStorage unavailable (private mode, quota) — nothing to wipe */
}
